module.exports = {
    PDF_LETTER_NORMAL_HEIGHT: 500,
    PDF_LETTER_MODAL_SCALE: 2.0,
    PDF_LETTER_NORMAL_SCALE: 1.1
}